export default __webpack_public_path__ + "static/work-e79f30d1147dcdd4ed5cd3877ab1aefc.svg";